import React, { useState, useEffect } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
// import "../../styles/practitionerpage.css";
import "../../styles/homepage.css";
import { Link } from "react-router-dom";
import womanPC from "../../img/registerWaitlist.png";
import { useDispatch } from "react-redux";
import { NewFooter } from "../../components/newFooter";
import "../../styles/waitlistRegister.css";
import { useDeprecatedAnimatedState } from "framer-motion";
import butterfly1 from "../../img/Butterfly1.png";
import { createUser } from "../../features/user/userSlice";

export const WaitlistRegister = (props) => {
  console.log(props?.location?.state);
  const dispatch = useDispatch();

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const [userData, setUserData] = useState({});

  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  return (
    <div>
      <div className="bg-waitlist-register">
        <div className="padding-logo-aling pt-4">
          <h2 className="padding-top-userpages fs-48-32-30">
            Sign Up for the Waitlist
          </h2>
        </div>
        <div className="d-flex justify-content-between align-baseline padding-logo-aling">
          <div>
            <div className="d-grid mt-4 mb-4">
              <label className="text-dm">First name</label>
              <input
                className="input-waitlist"
                name="firstName"
                value={userData?.firstName}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    [e.target.name]: e.target.value,
                  })
                }
              ></input>
            </div>
            <div className="d-grid mt-4">
              <label className="text-dm">Last name</label>
              <input
                className="input-waitlist"
                name="lastName"
                value={userData?.lastName}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    [e.target.name]: e.target.value,
                  })
                }
              ></input>
            </div>
            <div className="d-grid mt-4">
              <label className="text-dm">Email address</label>
              <input
                className="input-waitlist"
                name="email"
                value={userData?.email}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    [e.target.name]: e.target.value,
                  })
                }
              ></input>
            </div>
            <div className="d-grid mt-4">
              <label className="text-dm">
                Choose a Password{" "}
                <span className="fs-12">(9 characters minimum)</span>
              </label>
              <input
                className="input-waitlist"
                name="password"
                value={userData?.password}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    [e.target.name]: e.target.value,
                  })
                }
              ></input>
            </div>
            <div className="mt-4 controller-width-text">
              <p className="fs-10 text-dm">
                I consent to Elana Inc. processing data I provide, so that Elana
                Inc. can provide services to me. In addition, by clicking ‘Sign
                up’ I acknowledge that I have read and agree to Elana’s Privacy
                Policy and Terms and Conditions. I agree to receive emails and
                updates from Elana Inc.
              </p>
            </div>
            <div className="pt-4 pb-4">
              <button
                className="button-newindividualpage blue-hover"
                onClick={() => {
                  dispatch(createUser(userData));
                  setUserData({});
                  toggleShow();
                }}
              >
                SIGN UP
              </button>
            </div>
          </div>
          <div className="">
            <img
              src={womanPC}
              className="image-waitlist padding-right no-phone"
            />
          </div>
        </div>

        <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
          <MDBModalDialog size="lg" rounded className="p-5">
            <MDBModalContent className="bg-modal-option">
              <MDBModalBody>
                <div className="d-flex justify-content-end">
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={toggleShow}
                  ></MDBBtn>
                </div>
                <div className="items-controller mt-3 mb-3">
                  <img src={butterfly1} className="butterfly1"></img>
                </div>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Thank you for Signing Up with Elana!
                </p>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Check your inbox for an email confirmation.
                  <br />
                  We’re so glad you're here, and look forward to being a<br/>
                  part of your pelvic care journey!
                </p>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
      <NewFooter />
    </div>
  );
};
